export default function WhyChooseSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 mb-3">
            Why Choose Us
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            Why Shoppers Prefer Spreadsheet Research
          </h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-xl mx-auto">
            See how organized spreadsheet research transforms your shopping experience compared to traditional browsing
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse min-w-[600px]">
            <thead>
              <tr>
                <th className="text-left py-4 px-4 md:px-6 text-sm font-semibold text-foreground-700 border-b-2 border-background-200">
                  Feature
                </th>
                <th className="text-center py-4 px-4 md:px-6 text-sm font-semibold text-foreground-500 border-b-2 border-background-200">
                  <div className="flex items-center justify-center gap-2">
                    <i className="ri-search-line text-foreground-400"></i>
                    Normal Search
                  </div>
                </th>
                <th className="text-center py-4 px-4 md:px-6 text-sm font-semibold text-primary-600 border-b-2 border-primary-200 bg-primary-50/50 rounded-t-lg">
                  <div className="flex items-center justify-center gap-2">
                    <i className="ri-database-2-line text-primary-500"></i>
                    Hipobuy Spreadsheet
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {[
                { feature: 'Product Discovery', normal: 'Slow & Unorganized', hipobuy: 'Fast & Structured', normalIcon: 'ri-close-circle-line text-accent-500', hipobuyIcon: 'ri-checkbox-circle-line text-primary-500' },
                { feature: 'Category Browsing', normal: 'Limited Filtering', hipobuy: 'Advanced Categories', normalIcon: 'ri-close-circle-line text-accent-500', hipobuyIcon: 'ri-checkbox-circle-line text-primary-500' },
                { feature: 'Research Efficiency', normal: 'Time Consuming', hipobuy: 'Highly Efficient', normalIcon: 'ri-close-circle-line text-accent-500', hipobuyIcon: 'ri-checkbox-circle-line text-primary-500' },
                { feature: 'Product Comparison', normal: 'Difficult', hipobuy: 'Simple & Clear', normalIcon: 'ri-close-circle-line text-accent-500', hipobuyIcon: 'ri-checkbox-circle-line text-primary-500' },
                { feature: 'Beginner Friendly', normal: 'No', hipobuy: 'Yes', normalIcon: 'ri-close-circle-line text-accent-500', hipobuyIcon: 'ri-checkbox-circle-line text-primary-500' },
                { feature: 'Update Frequency', normal: 'Irregular', hipobuy: 'Regular Updates', normalIcon: 'ri-close-circle-line text-accent-500', hipobuyIcon: 'ri-checkbox-circle-line text-primary-500' },
              ].map((row, idx) => (
                <tr key={idx} className={idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                  <td className="py-4 px-4 md:px-6 text-sm font-medium text-foreground-800 border-b border-background-200">
                    {row.feature}
                  </td>
                  <td className="py-4 px-4 md:px-6 text-center border-b border-background-200">
                    <div className="flex items-center justify-center gap-1.5">
                      <i className={row.normalIcon}></i>
                      <span className="text-sm text-foreground-500">{row.normal}</span>
                    </div>
                  </td>
                  <td className="py-4 px-4 md:px-6 text-center border-b border-background-200 bg-primary-50/20">
                    <div className="flex items-center justify-center gap-1.5">
                      <i className={row.hipobuyIcon}></i>
                      <span className="text-sm text-primary-700 font-medium">{row.hipobuy}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}